<template>
	<div class="khfw">
		<div class="cardK">
			<div class="card">
				<div class="title">
					当日工单情况统计
				</div>
				<div class="content content1">
					<div class="icon">
						<img src="@/assets/khfw/1.png" class="icon1" alt="" />
						<img src="@/assets/khfw/2.png" class="icon2" alt="" />
					</div>
					<div class="info">
						<p class="inner1">总数<span>13</span></p>
						<div>
							<div class="inner2">

								<div class="">
									<p>同比<span class="success">0.00%</span></p>
									<p>环比<span class="danger">-15.56%</span></p>
								</div>
							</div>
							<div class="inner1">
								<p>客户工单数量<span>12</span></p>
								<p>自检工单数量<span>1</span></p>
							</div>

						</div>
						<div class="progress">
							<p>完成率<span>80%</span></p>
							<div class="progressInner">
								<div class="progressValue" style="width: 80%;"></div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card card2">
				<div class="title">
					当日所有工单及完成情况
				</div>
				<div class="content sbxj">
					<div class="viewList" ref="viewList">
						<div class="viewListTh">
							<div class="viewListTd">工单号</div>
							<div class="viewListTd">业务类型</div>
							<div class="viewListTd">任务状态</div>
						</div>
						<div class="viewListScroll" ref="viewListScroll" @mousemove="isIn = true"
							@mouseleave="isIn = false" :style="{transform: 'translateY(-' + moveNum + 'px)'}">
							<div class="viewListTr" v-for="(item,index) in viewList" :key="index">
								<div class="viewListTd clamp_1 ">{{item.instanceName}}</div><!--{{item.deviceNames}}-->
								<div class="viewListTd clamp_1">{{item.instanceNo}}</div><!--{{item.taskNo}}-->
								<div class="viewListTd clamp_1">{{status[item.status]}}</div>
							</div>
							<div class="viewListTr" v-for="(item,index) in viewList" :key="'i'+index">
								<div class="viewListTd clamp_1">{{item.instanceName}}</div><!--{{item.deviceNames}}-->
								<div class="viewListTd clamp_1">{{item.instanceNo}}</div><!--{{item.taskNo}}-->
								<div class="viewListTd clamp_1">{{status[item.status]}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="cardK">
			<div class="card">
				<div class="title">
					工单详情
				</div>
				<div class="content contentZ1">
					<div class="gsItem">
						<div class="gsInners">
							<div class="gsItemIn">
								<p>区域</p>
								<span>1</span>
							</div>
							<div class="gsItemIn">
								<p>项目</p>
								<span>2</span>
								<img src="@/assets/khfw/icon1.png" alt="">
							</div>
						</div>
						<div class="gsTitle">
							<span>服务户数</span>
						</div>
						<div class="num">
							<span>3</span>
							<div class="type">同比 <span class="success">2.00%</span></div>
						</div>

						<div class="gsInners">
							<div class="gsItemIn">
								<p>7-2项目</p>
								<span>1</span>
							</div>
							<div class="gsItemIn">
								<p>7-5项目</p>
								<span>2</span>
							</div>
						</div>
					</div>
					<div class="gsItem">
						<div class="gsTitle">
							<span>2025年度工单总量</span>
							<img src="@/assets/khfw/icon2.png" alt="">
						</div>
						<div class="num">
							425
						</div>
						<div class="gsInners">
							<div class="gsItemIn gsItemIn2">
								<p>客户工单数：<span>349</span></p>
							</div>
						</div>
						<div class="gsInners">
							<div class="gsItemIn gsItemIn2">
								<p>自检工单数：<span>76</span></p>
							</div>
						</div>
						<div class="gsInners">
							<div class="gsItemIn gsItemIn2">
								<p>完成率</p>
								<span>88.00%</span>
							</div>
							<div class="gsItemIn gsItemIn2">
								<p>满意度</p>
								<span>98.00%</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="title">工单分类</div>
				<div class="content contentY">
					<div class="yChart" id="chart3" ref="chart3"></div>
					<div class="zong">
						<span>总数</span>
						<span>25</span>
					</div>
					<div class="legend" style="padding: 40px 0;">
						<div class="legendItem" style="width: 33%;" v-for="(item,index) in chart3Data.series[0].data"
							:key="index">
							<i :style="{background: item.itemStyle.color}"></i>
							<div class="r">
								<span>{{item.name}}</span>
								<p>{{item.value}}%</p>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="card">
				<div class="title">工单来源</div>
				<div class="content contentY">
					<div class="yChart" id="chart4" ref="chart4"></div>
					<div class="zong">
						<span>总数</span>
						<span>26</span>
					</div>
					<div class="legend" style="justify-content: space-between;">
						<!-- legendItem2 -->
						<div class="legendItem " v-for="(item,index) in chart4Data.series[0].data" :key="index">
							<i :style="{background: item.itemStyle.color}"></i>
							<div class="r">
								<span>{{item.name}}</span>
								<p>{{item.value}}%</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="cardK">
			<div class="card">
				<div class="title">
					当月工单情况统计
				</div>
				<div class="content content1">
					<div class="icon">
						<img src="@/assets/khfw/3.png" class="icon1" alt="" />
						<img src="@/assets/khfw/4.png" class="icon2" alt="" />
					</div>
					<div class="info">
						<p class="inner1">总数<span>110</span></p>
						<div>
							<div class="inner2">
								<div class="">
									<p>同比<span class="success">0.00%</span></p>
									<p>环比<span class="danger">-3.76%</span></p>
								</div>
							</div>
							<div class="inner1">
								<p>客户工单数量<span>84</span></p>
								<p>自检工单数量<span>26</span></p>
							</div>

						</div>
						<div class="progress">
							<p>完成率<span>79%</span></p>
							<div class="progressInner">
								<div class="progressValue" style="width: 88%;"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="title">
					客户工单完成情况分析
				</div>
				<div class="content" id="chart5" ref="chart5"></div>
			</div>
			<div class="card">
				<div class="title">
					工单及时完成情况分析
				</div>
				<div class="content" id="chart6" ref="chart6"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		chart1,
		chart2,
		chart3,
		chart4,
		chart5,
		chart6,
	} from '../common/options.js';
	import * as echarts from 'echarts';
	console.log(chart6)
	export default {
		data() {
			return {
				timer: null,
				chart1: null,
				chart2: null,
				chart3: null,
				chart4: null,
				chart5: null,
				chart6: null,
				chart3Data: chart3,
				chart4Data: chart4,
				moveNum: 0,

				viewList: [],
				status: {
					customer: '客服待确认',
					manager: '主管待确认',
					final: '待确认最终金额',
					estimate: '待确认预计金额',
					completed: '已完成',
					bereleased: '待发布',
					finished: '已关闭',
					appraising: '待评价',
					following: '待回访',
					confirming: '待确认',
					dispatching: '待分配',
					pending: '待处理',
					running: '处理中',
				}
			}
		},
		created() {
			this.$nextTick(_ => {
				this.setChart();
				this.moveList();
			})
			let _self = this;
			window.addEventListener('resize', function() {
				clearTimeout(_self.timer)
				_self.timer = setTimeout(_ => {
					_self.resize()
				}, 1000)
			})
		},
		methods: {
			moveList() {
				let viewListScroll = this.$refs.viewListScroll;
				if (this.moveNum > viewListScroll.offsetHeight / 2) {
					this.moveNum = 0
				}
				if (!this.isIn)
					this.moveNum++;
				setTimeout(_ => {
					this.moveList();
				}, 30)
			},
			resize() {
				// this.chart1.resize();
				// this.chart2.resize();
				this.chart3.resize();
				this.chart4.resize();
				this.chart5.resize();
				this.chart6.resize();
			},
			setChart() {
				console.log(1111)
				// this.chart1 = echarts.init(this.$refs.chart1);
				// this.chart1.setOption(chart1);

				// this.chart2 = echarts.init(this.$refs.chart2);
				// this.chart2.setOption(chart2);

				this.chart3 = echarts.init(this.$refs.chart3, null, {
					devicePixelRatio: 2.5
				});
				this.chart3.setOption(chart3);

				this.chart4 = echarts.init(this.$refs.chart4, null, {
					devicePixelRatio: 2.5
				});
				this.chart4.setOption(chart4);

				this.chart5 = echarts.init(this.$refs.chart5, null, {
					devicePixelRatio: 2.5
				});
				this.chart5.setOption(chart5);

				this.chart6 = echarts.init(this.$refs.chart6, null, {
					devicePixelRatio: 2.5
				});
				this.chart6.setOption(chart6);


				this.$axios.get(this.$baseUrl + '/process/instance/getIntraDayTaskList?pageSize=30').then(res => {
					if (res.status == 200 && res.data.code == 200) {
						this.viewList = res.data.data;
					}
				})


			}
		}
	}
</script>

<style lang="scss" scoped>
	$main-color: #3ED4EB;
	$blue: #2B9AE4;

	.clamp_1 {
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		display: -webkit-box !important;
		-webkit-box-orient: vertical;
	}


	div {
		box-sizing: border-box;
	}

	.khfw {
		overflow: hidden;
		flex: 1;
		display: flex;
		flex-direction: row !important;
		justify-content: space-between;
		align-items: stretch;
		box-sizing: border-box;
		padding: 20px 26px 0;

		.cardK {
			width: 33%;
			max-width: 33%;
			height: 84vh;
			padding: 0 10px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.card {
				width: 100%;
				flex: 1;
				overflow: hidden;
				// background: linear-gradient(to right, #16213A 0%, #081E2F 50%, #16213A 100%);
				padding: 20px 18px;
				margin-bottom: 15px;
				display: flex;
				flex-direction: column;
				transition: all .2s;

				&.card2 {
					flex: 2;
				}

				&:last-child {
					margin-bottom: 0;
				}

				.title {
					&:before {
						content: '';
						display: flex;
						width: 14px;
						height: 14px;
						border: 2px solid #57C9DE;
						background: #0667D4;
						margin-right: 12px;
					}

					display: flex;
					font-size: 20px;
					color: #FFF;
					flex-direction: row;
					justify-content: flex-start;
					align-items: center;
					font-weight: 500;
					user-select: none;
					line-height: 20px;
				}

				.content {
					height: 100%;

					&.sbxj {
						margin-top: 20px;
						max-height: 100%;
						position: relative;
						padding-top: 36px;

						.viewList {
							flex: 1;
							max-height: 100%;
							// padding: 0 8px 8px;
							overflow: hidden;
						}

						.viewListTh {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;
							width: 100%;
							height: 36px;
							background: #113F73;
							font-size: 14px;
							z-index: 2;
							position: absolute;
							top: 0;
							left: 0;
							white-space: nowrap;

							.viewListTd {
								flex: 2;
								padding: 0 10px;
								color: #07DBFF;
								white-space: nowrap;
								display: flex;
							}

							.viewListTd:last-child {
								flex: 1;
								justify-content: center;
								align-items: center;
							}
						}

						.viewListTh2 {
							.viewListTd:last-child {
								flex: 2;
								justify-content: flex-start;
								align-items: flex-start;
							}
						}


						.viewListScroll {
							max-height: 100%;
							overflow: hidden;
							z-index: 1;

							.viewListTr {
								display: flex;
								border: 1px solid transparent;
								border-bottom: 1px solid #09718F;
								flex-direction: row;
								justify-content: space-between;
								align-items: center;
								height: 40px;
								position: relative;
								font-size: 14px;

								.viewListTd {
									padding: 0 10px;
									color: #CCC;
									flex: 2;
									display: flex;
									user-select: all;
									white-space: nowrap;
								}

								.viewListTd:first-child {
									color: #FFF;
								}

								.viewListTd:last-child {
									flex: 1;
									justify-content: center;
									align-items: center;
								}


								&:hover {
									border: 1px solid #07DBFF;
									box-shadow: 0 0 10px 0 #07DBFF inset;
								}

								&:hover::after {
									content: '';
									display: block;
									border-top: 6px solid transparent;
									border-right: 6px solid #07DBFF;
									border-bottom: 6px solid transparent;
									border-left: 6px solid transparent;
									position: absolute;
									right: 8px;
								}
							}

							&.viewListScroll2 {
								.viewListTd:last-child {
									flex: 2;
									justify-content: flex-start;
									align-items: flex-start;
								}
							}




							.viewListTitle {
								font-size: 14px;
								color: #FFF;
								display: flex;
								flex-direction: column;
								justify-content: center;
								align-items: center;
								height: 36px;
								min-height: 36px;
								letter-spacing: 3px;
								background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, #043D85 36%, #043D85 64%, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0) 100%);
							}

							.viewListTitle::after {
								content: '';
								display: flex;
								width: 70%;
								height: 2px;
								background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, #31b7ff 30%, #FFF 50%, #31b7ff 70%, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0) 100%);
							}
						}
					}
				}

				.content1 {
					flex-direction: row;
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 0 2%;

					@keyframes iconKMove {
						0% {
							transform: translateY(-4px);
						}

						50% {
							transform: translateY(4px);
						}

						100% {
							transform: translateY(-4px);
						}
					}

					.icon {
						position: relative;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 166px;
						height: 100%;
						animation: iconKMove 2s infinite;

						@keyframes iconMove {
							0% {
								opacity: 1;
							}

							50% {
								opacity: .3;
							}

							100% {
								opacity: 1;
							}
						}

						.icon1 {
							width: 126px;
							position: absolute;
							z-index: 1;
							transform: translateY(36px);
						}

						.icon2 {
							width: 166px;
							position: absolute;
							z-index: 2;
							transform: translateY(50px);
							animation: iconMove 3s infinite;
						}
					}

					.info {
						flex: 1;
						height: 100%;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						box-sizing: border-box;
						padding: 20px 0 10px;
						padding-left: 26px;

						.inner1 {
							font-size: 16px;
							line-height: 16px;
							color: $main-color;
							display: flex;
							flex-direction: row;
							justify-content: flex-start;
							align-items: center;

							p {
								flex: 1;
							}

							span {
								font-size: 28px;
								line-height: 40px;
								color: #FFF;
								font-weight: 500;
								padding-left: 10px;
							}
						}

						.inner2 {
							width: 100%;
							margin-bottom: 20px;

							// display: flex;
							// flex-direction: row;
							// justify-content: space-between;
							// align-items: flex-end;
							>span,
							>div {
								flex: 1;
							}

							>span {
								font-size: 26px;
								color: #FFF;
								line-height: 40px;
							}

							div {
								display: flex;
								flex-direction: row;
								justify-content: space-between;
								align-items: center;

								p {
									flex: 1;
									color: $blue;
									display: flex;
									flex-direction: row;
									justify-content: flex-start;
									font-size: 16px;
									line-height: 20px;
									margin-top: 4px;

									span {
										padding-left: 20px;
										position: relative;
										font-weight: bold;

										&:before {
											content: '';
											position: absolute;
											top: 4px;
											left: 8px;
											display: flex;
											border-top: 3px solid;
											border-left: 3px solid;
											border-right: 3px solid transparent;
											border-bottom: 3px solid transparent;
											width: 0;
											height: 0;
											transform: rotateZ(45deg);
										}

										&::after {
											content: '';
											position: absolute;
											width: 4px;
											height: 8px;
											left: 9px;
											top: 8px;
											transform: scale(.8);
										}

										&.success {
											color: #ABFF9B;

											&:before {
												border-top: 4px solid #ABFF9B;
												border-left: 4px solid #ABFF9B;
												border-right: 4px solid transparent;
												border-bottom: 4px solid transparent;
												transform: rotateZ(45deg) translate(0px, 1px) scale(.7);
											}

											&::after {
												background: #ABFF9B;
												top: 8px;
											}
										}

										&.danger {
											color: #BD1B3C;

											&:before {
												border-top: 4px solid #BD1B3C;
												border-left: 4px solid #BD1B3C;
												border-right: 4px solid transparent;
												border-bottom: 4px solid transparent;
												transform: rotateZ(-135deg) translate(-2px, -3px) scale(.8);
											}

											&::after {
												top: 5px;
												background: #BD1B3C;
											}
										}
									}
								}
							}
						}


						.progress {
							p {
								font-size: 20px;
								color: $main-color;

								span {
									margin-left: 10px;
									color: #FFF;
								}
							}

							@keyframes progressMove {
								0% {
									transform: scaleX(0);
								}

								100% {
									transform: scaleX(1);
								}
							}

							.progressInner {
								width: 100%;
								height: 11px;
								background: #2C526C;

								.progressValue {

									height: 100%;
									background: $blue;
									transform-origin: left top;
									animation: progressMove 1s forwards;
								}
							}
						}
					}
				}

				.contentY {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: stretch;
					position: relative;

					.zong {
						position: absolute;
						top: calc(50% - 26px);
						left: calc(20% - 30px);
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						width: 60px;
						height: 60px;
						font-size: 15px;

					}

					.yChart {
						width: 40%;
						height: 100%;
					}

					.legend {
						flex: 1;
						display: flex;
						flex-direction: row;
						justify-content: flex-start;
						align-items: center;
						flex-wrap: wrap;

						// 
						.legendItem {

							display: flex;
							flex-direction: row;
							justify-content: flex-start;
							align-items: flex-start;

							&.legendItem2 {
								width: 25%;
							}

							i {
								display: flex;
								width: 12px;
								min-width: 12px;
								height: 12px;
								border-radius: 50%;
								margin: 5px 6px 0 0;
							}

							div {
								span {
									font-size: 14px;
									color: $main-color;
									line-height: 20px;
									white-space: nowrap;
								}

								p {
									font-size: 22px;
									color: #FFF;
									line-height: 30px;
									white-space: nowrap;
								}
							}
						}
					}
				}


				.contentZ1 {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: stretch;
					flex: 1;

					.gsItem {
						flex: 1;
						background: rgba(36, 54, 84, .5);
						margin: 10px 15px 0;
						padding: 20px 20px 10px;
						display: flex;
						flex-direction: column;
						justify-content: space-around;
						transition: all .2s;

						&:hover {
							background: rgba(36, 54, 84, 1);
						}

						.gsTitle {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;

							span {
								font-size: 18px;
								color: $main-color;
							}

							img {
								// width: 20px;
								height: 24px;
							}
						}

						.num {
							font-size: 40px;
							line-height: 46px;
							color: #FFF;
							display: flex;
							flex-direction: row;
							justify-content: flex-start;
							align-items: center;

							>span {
								flex: 1;
							}

							div {
								font-size: 12px;
								flex: 1;

								span {
									color: #abff9b;
									padding-left: 12px;
									position: relative;
									font-weight: bold;

									&:before {
										content: '';
										position: absolute;
										top: 2px;
										left: 3px;
										display: flex;
										border-top: 3px solid;
										border-left: 3px solid;
										border-right: 3px solid transparent;
										border-bottom: 3px solid transparent;
										width: 0;
										height: 0;
										transform: rotateZ(45deg);
									}

									&::after {
										content: '';
										position: absolute;
										width: 4px;
										height: 8px;
										left: 4px;
										top: 6px !important;
										transform: scale(.8);
									}

									&.success {
										&:before {
											border-top: 4px solid #ABFF9B;
											border-left: 4px solid #ABFF9B;
											border-right: 4px solid transparent;
											border-bottom: 4px solid transparent;
											transform: rotateZ(45deg) translate(0px, 1px) scale(.7);
										}

										&::after {
											background: #ABFF9B;
											top: 8px;
										}
									}

								}
							}
						}

						.gsInners {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;
							width: 100%;

							&:last-child {
								margin-top: 5px;
							}

							.gsItemIn {
								flex: 1;
								display: flex;
								flex-direction: row;
								justify-content: flex-start;
								align-items: center;

								p {
									color: $main-color;
									font-size: 16px;
									line-height: 20px;
									white-space: nowrap;
								}

								img {
									// width: 20px;
									height: 24px;
									margin-left: 50px;
								}

								span {
									font-size: 18px;
									line-height: 22px;
									white-space: nowrap;
									padding-left: 5px;
								}

								&.gsItemIn2 {
									flex-direction: column;
									align-items: flex-start;

									span {
										padding-left: 0;
										color: #FFF;
									}
								}

							}
						}
					}
				}


			}
		}
	}
</style>